import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactTemplate } from '@bingads-webui-react/react-template';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { ConfirmDialog } from '../common';
import { getStyles } from '../styles/identity-verification-dialog';

const ChinaAIVSingleAccountContent = ({
  i18n,
  compositeStatusText,
  subjectVerificationStatus,
  confirmText,
}) => {
  const classes = useDefaultStyles(getStyles);
  const contentTemplate = i18n.getString(_TL_('Both your advertiser identity verification (AIV) status and qualification status share the same business location across your accounts. You’ve provided an updated business location to your AIV status {{subjectVerificationStatus}}. Selecting {{confirmText}} means that your AIV status or qualification status might change, and your account will be {{compositeStatusText}}. All shareable qualification(s) under this business location will also be updated on the {{verificationLink}} page.'));
  return (
    <div className={classNames(classes.content)}>
      <ReactTemplate
        model={{
          subjectVerificationStatus: <span className="bold">{subjectVerificationStatus}</span>,
          compositeStatusText: <span className="bold">{compositeStatusText}</span>,
          confirmText: <span className="bold">{confirmText}</span>,
          verificationLink: <span className="bold">{i18n.getString(_TL_('Verification'))}</span>,
        }}
        template={contentTemplate}
      />
    </div>
  );
};

const ChinaAIVBulkAccountContent = ({
  i18n, confirmText,
}) => {
  const classes = useDefaultStyles(getStyles);
  const contentTemplate = i18n.getString(_TL_('Both your advertiser identification status (AIV) status and other qualification status share the same business location across your accounts. Selecting {{confirmText}} means that your AIV status or qualification status might change, which might impact the account status. All shareable qualification(s) under this business location will also be updated on the {{verificationLink}} page.'));
  return (
    <div className={classNames(classes.content)}>
      <ReactTemplate
        model={{
          confirmText: <span className="bold">{confirmText}</span>,
          verificationLink: <span className="bold">{i18n.getString(_TL_('Verification'))}</span>,
        }}
        template={contentTemplate}
      />
    </div>
  );
};

export const ChinaVerificationStatusChangeDialog = ({
  i18n,
  subjectVerificationStatus,
  onConfirm,
  onDecline,
  isSingleAccount,
  compositeStatusText,
}) => {
  const ContentComponent = isSingleAccount ? ChinaAIVSingleAccountContent : ChinaAIVBulkAccountContent;
  return (<ConfirmDialog
    name="china-verification-status-change"
    onConfirm={onConfirm}
    onDecline={onDecline}
    title={i18n.getString(_TL_('Possible changes to your advertiser identity verification status or qualification status'))}
    content={<ContentComponent
      confirmText={i18n.getString(_TL_('Proceed'))}
      i18n={i18n}
      compositeStatusText={compositeStatusText}
      subjectVerificationStatus={subjectVerificationStatus}
    />}
    confirmButtonText={i18n.getString(_TL_('Proceed'))}
    declineButtonText={i18n.getString(_TL_('Cancel'))}
  />);
};

ChinaVerificationStatusChangeDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  subjectVerificationStatus: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  isSingleAccount: PropTypes.bool.isRequired,
  compositeStatusText: PropTypes.string,
};

ChinaVerificationStatusChangeDialog.defaultProps = {
  subjectVerificationStatus: null,
  compositeStatusText: null,
};

ChinaAIVSingleAccountContent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  compositeStatusText: PropTypes.string.isRequired,
  subjectVerificationStatus: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
};

ChinaAIVBulkAccountContent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  confirmText: PropTypes.string.isRequired,
};
